import { useState, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import CloneAppModal from '../components/CloneAppModal'
import { getCloneNotice } from '../lib/cloneFeedback'
import { type App } from '../lib/api'

export function useCloneApp() {
  const navigate = useNavigate()
  const [target, setTarget] = useState<App | null>(null)

  const startClone = useCallback((app: App) => setTarget(app), [])

  const modal = useMemo(() => {
    if (!target) return null
    return (
      <CloneAppModal
        app={target}
        onClose={() => setTarget(null)}
        onCloned={(response) => {
          setTarget(null)
          navigate(`/apps/${response.name}`, {
            state: { cloneNotice: getCloneNotice(response) },
          })
        }}
      />
    )
  }, [target, navigate])

  return { startClone, modal }
}
